import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Grid, Stack, Typography } from '@mui/material';
import { Convert, FnAxios, FnDialog, I18n, ParseHtml, RouterDOM } from 'utilities/utilities';
import TabQuater from './TabQuater';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { FormProvider, useForm } from 'react-hook-form';
import Tabs, { TabItem, TabContent, TabPanel } from 'components/Input/Tab';
import { BtnApprove, BtnCancel, BtnDraft, BtnEdit, BtnRecall, BtnSave, BtnSendRequest } from 'components/Button/ButtonAll';
import { ProjectContext } from '../../ProjectRequestFrom';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router';
import { ApiProject } from 'enum/api';
import { APIStatusCode, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import ModalRemark from '../../components/Modal/ModalRemark';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import { TextAreaItem } from 'components/Input/TextArea';
import UploadFileItem from 'components/Input/UploadFile';

const ProjectUpdateProgressContext = createContext(null);
const RequestKth31Page = () => {
    const {
        nProjectID,
        isPermission,
        ObjProjectRequest,
        nStatusID,
        ObjStepFlowProject,
        isModeSecretary,
        sPathNameBack,
        sMode,
        nProgressStatusID,
        isChangeUpdateProgress,
        setisChangeUpdateProgress,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const Router = RouterDOM();
    const navigate = useNavigate();

    //#region useState
    const sBackgroundTab = "rgb(50 140 159)"; //"rgb(175 175 175)";    
    const sBackgroundTabActive = "linear-gradient(rgb(15 188 213) 33%, rgb(75 196 235 / 57%) 71%, rgb(165 246 255 / 68%) 87%, rgb(255, 255, 255) 100%)";

    const [TabQuaterID, setTabQuaterID] = useState(null);

    const [arrYear, setarrYear] = useState([]);
    const [arrQuater, setarrQuater] = useState([]);
    // const [arrQuater, setarrQuater] = useState([
    //     { key: "Quater1", value: "1", label: "<span>สิ้นไตรมาส 1 (มกราคม - มีนาคม)</span>" },
    //     { key: "Quater2", value: "2", label: "<span>สิ้นไตรมาส 2 (เมษายน - มิถุนายน)</span>" },
    //     { key: "Quater3", value: "3", label: "<span>สิ้นไตรมาส 3 (กรกฎาคม - กันยายน)</span>" },
    //     { key: "Quater4", value: "4", label: "<span>สิ้นไตรมาส 4 (ตุลาคม - ธันวาคม)</span>" },
    // ])
    const currentDate = new Date(); // Get the current date
    const [_dStart, setdStart] = useState(new Date(currentDate.getFullYear(), 0, 1)); //01/01/Year New
    const [_dEnd, setdEnd] = useState(new Date(currentDate.getFullYear(), 12, 0)); //31/12/Year New 

    const [sActivitySummarize, setsActivitySummarize] = useState(null);
    const [ObjDataProject, setObjDataProject] = useState(null);

    const [nQuaterID, setnQuaterID] = useState(null);
    // const [isPlan, setisPlan] = useState(null); //isPlan >> โหมด T = WorkPlan | F = SpendingPlan

    const [_lstProjectWorkPlan, set_lstProjectWorkPlan] = useState([]);
    const [_lstProjectSpendingPlanType, set_lstProjectSpendingPlanType] = useState([]);

    const [nCurrentYear, setnCurrentYear] = useState(null);
    const [nCurrentQ, setnCurrentQ] = useState(null);
    const [isQuaterEnd, setisQuaterEnd] = useState(null); //ไตรมาส สุดท้าย   

    const [nProgressID, setnProgressID] = useState(0);
    const [_nProgressStatusID, set_nProgressStatusID] = useState(0);
    const [_nUpdateProgressStatusID, set_nUpdateProgressStatusID] = useState(0);
    const [nApproveBudget, setnApproveBudget] = useState(null);

    const [isEdit, setisEdit] = useState(false);
    const [isEditSecretary, setisEditSecretary] = useState(null);

    const [isEditProgressOld, setisEditProgressOld] = useState(false); // Enh.2025 > เลขา กดบันทึกและยอมรับผล : ยังสามารถแก้ไข Q ไตรมาสที่ผ่านมาได้ < แก้ไขได้ กท 3/1 - แท็บ รายงานผลการปฎิบัติงาน: แก้ไขได้ทั้งหมด แสดงปุ่ม บันทึก - แท็บ รายงานผลการใช้จ่ายเงิน: แก้ไขไม่ได้ 
    const arrNotEditProgres = [25, 26, 27, 28, 29, 33, 36]; // Enh.2025 > เลขา แก้ไขไม่ได้แล้ว //35, 

    const [isModalRecallProgress, setisModalRecallProgress] = useState(false);
    // const [sRemark, setsRemark] = useState(null);    

    const [lstFileSpendingPlan_1, setlstFileSpendingPlan_1] = useState([]); //เอกสารแนบ << รายละเอียดรายงานผลการใช้จ่ายเงิน กท.3/1 > รายไตรมาส
    const [lstFileSpendingPlan_2, setlstFileSpendingPlan_2] = useState([]); //เอกสารแนบ << แบบรายงานสรุปผลการดำเนินงานรายไตรมาส กท.3/1 > รายไตรมาส
    //#endregion

    const formRemark = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sRemark: null,
        } as any,
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nYearID: null,
        } as any,
    });

    useEffect(() => {
        if (nProjectID !== 0) GetFormInitial();
    }, [nProjectID]);

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary]);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectQuater, { nProjectID: nProjectID, nYearID: null }, (result) => {
            setdStart(new Date(result.nStartDate));
            setdEnd(new Date(result.nEndDate));
            setarrYear(result.lstYearID ?? []);
            // let nYearID = result.lstYearID.length > 0 ? Convert.StringToIntOrNull(result.lstYearID[0].value) : null;
            form.setValue("nYearID", result.nCurrentYear);
            setnCurrentYear(result.nCurrentYear);
            setnCurrentQ(result.nCurrentQ);
            setisQuaterEnd(result.isQuaterEnd); //ไตรมาส สุดท้าย 
            GetFormQuater(result.nCurrentYear);
            setnApproveBudget(result.nApproveBudget); //งบประมาณโครงการทั้งหมดที่อนุมัติ
        });
    }

    const GetFormQuater = (nYearID, nTabQuaterID = null) => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectQuater, { nProjectID: nProjectID, nYearID: nYearID }, (result) => {
            setarrQuater([...result.lstQuaterID]);
            if (nTabQuaterID) {
                setTabQuaterID("Quater" + nTabQuaterID);
            }
            else {
                // setTabQuaterID(result.lstQuaterID.length > 0 ? result.lstQuaterID[0].key : "Quater1");
                if (nYearID <= result.nCurrentYear) {
                    setTabQuaterID("Quater" + (result.nCurrentYear === nYearID ? result.nCurrentQ : (result.lstQuaterID.length > 0 ? result.lstQuaterID[0].value : "1")));
                } else {
                    setTabQuaterID("Quater");
                }
            }
        });
    }

    const handleSubmit = (nModeID: EnumSaveModeProject, nStatusID: EnumProjectStatusID, sMessage: string,) => {
        let ObjData = form.getValues();

        //#region ทำเช็คเงื่อนไขทั้ง ผลงาน ผลเงิน ว่าต้องอัพเดตให้ครบตามไตรมาสที่มีแผนงานแผนเงิน
        let isError = false;
        let sWarning = "กรุณาตรวจสอบข้อมูลและเพิ่มข้อมูลระยะเวลา <br/>";

        //แผนงาน
        let nWorkPlanAll = _lstProjectWorkPlan.length;
        if (nWorkPlanAll === 0) {
            isError = true;
            sWarning = "กรุณาตรวจสอบข้อมูลรายงานผลการปฎิบัติงาน แผนงาน/กิจกรรม ไม่ถูกต้อง";
        }
        //แผนเงิน
        let nSpendingPlanAll = _lstProjectSpendingPlanType.length;
        if (nSpendingPlanAll === 0) {
            isError = true;
            sWarning = "กรุณาตรวจสอบข้อมูลรายงานผลการใช้จ่ายเงิน แผนงาน/กิจกรรม ไม่ถูกต้อง";
        }

        //ผลงาน
        let nWorkPlan = _lstProjectWorkPlan.filter(f => f.isSuccess === true).length;
        if (nWorkPlanAll !== nWorkPlan && (nModeID === EnumSaveModeProject.Submit || nModeID === EnumSaveModeProject.Approve || nModeID === EnumSaveModeProject.Save)) {
            isError = true;
            sWarning += "- ผลการปฎิบัติงาน <br/>";
        }
        //ผลงาน ต้องครบ 100%
        if ((nModeID === EnumSaveModeProject.Submit || nModeID === EnumSaveModeProject.Save) && nStatusID === EnumProjectStatusID.nStatusID_35) {
            //#region Weight แบบทุกกิจกรรม
            let clone = [..._lstProjectWorkPlan];
            //แผน
            // let lstDataPlan = [].concat(...clone.map(m => m.lstProjectPlanActivity));
            // let _nWeightPlanAll = lstDataPlan.map(m => parseInt(m.nWeightActivityAll) || 0).reduce((a, b) => a + b, 0);
            //ผล
            let lstData = [].concat(...clone.map(m => m.lstProjectPlanActivity));
            let _nWeightAll = lstData.map(m => parseInt(m.nActivityActualAll) || 0).reduce((a, b) => a + b, 0);
            //#endregion
            if (_nWeightAll !== 100) {
                isError = true;
                sWarning += "- ผลการปฎิบัติงาน : ค่าน้ำหนักต้องเท่ากับ 100 เท่านั้นถึงจะรายงานผลไตรมาสสุดท้ายได้ <br/>";
            }
        }
        //ผลเงิน
        let nSpendingPlan = _lstProjectSpendingPlanType.filter(f => f.isSuccess === true).length;
        if (nSpendingPlanAll !== nSpendingPlan && (nModeID === EnumSaveModeProject.Submit || nModeID === EnumSaveModeProject.Approve)) {
            isError = true;
            sWarning += "- ผลการใช้จ่ายเงินงบประมาณ <br/>";
        }

        if (isError) {
            return DialogFn.Warning(sWarning);
        }

        let isErrorFile = false;
        let sWarningFile = "กรุณาอัพโหลดไฟล์ข้อมูล <br/>";
        //เอกสารแนบ << รายละเอียดรายงานผลการใช้จ่ายเงิน กท.3/1 > รายไตรมาส 
        //Enh.2025 เปลี่ยนชื่อ รายละเอียดรายงานผลการใช้จ่ายเงิน เป็น แบบรายงานผลการดำเนินงานโครงการ (แบบ กท. 3/1)
        if (lstFileSpendingPlan_1.length === 0 && (nModeID === EnumSaveModeProject.Submit || nModeID === EnumSaveModeProject.Approve || nModeID === EnumSaveModeProject.Save)) {
            isErrorFile = true;
            sWarningFile += "- แบบรายงานผลการดำเนินงานโครงการ (แบบ กท. 3/1) <br/>";
        }
        //เอกสารแนบ << แบบรายงานสรุปผลการดำเนินงานรายไตรมาส กท.3/1 > รายไตรมาส
        //Enh.2025 เปลี่ยนชื่อ แบบรายงานสรุปผลการดำเนินงานรายไตรมาส เป็น เอกสารประกอบการเบิกจ่าย
        if (lstFileSpendingPlan_2.length === 0 && (nModeID === EnumSaveModeProject.Submit || nModeID === EnumSaveModeProject.Approve)) {
            isErrorFile = true;
            sWarningFile += "- เอกสารประกอบการเบิกจ่าย <br/>";
        }
        if (isErrorFile) {
            return DialogFn.Warning(sWarningFile);
        }
        //#endregion

        let param = {
            sLocation: location.pathname,
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nStatusID: nStatusID,

            nCurrentYear: nCurrentYear,
            nCurrentQ: nCurrentQ,
            isQuaterEnd: isQuaterEnd, //ไตรมาส สุดท้าย           
            ObjDataProject: ObjDataProject,

            nProgressStatusID: _nProgressStatusID,
            nUpdateProgressStatusID: _nUpdateProgressStatusID,
            nYearID: ObjData.nYearID,
            nQuaterID: nQuaterID,
            nProgressID: nProgressID,
            // isPlan: isPlan, //isPlan >> โหมด T = WorkPlan | F = SpendingPlan
            sActivitySummarize: sActivitySummarize, // ปัญหา / อุปสรรค / แนวทางการแก้ไข
            lstProjectWorkPlan: _lstProjectWorkPlan,
            lstProjectSpendingPlanType: _lstProjectSpendingPlanType,

            sRemark: formRemark.getValues("sRemark") ?? null,

            lstFileSpendingPlan_1: lstFileSpendingPlan_1, //เอกสารแนบ << รายละเอียดรายงานผลการใช้จ่ายเงิน กท.3/1 > รายไตรมาส //Enh.2025 เปลี่ยนชื่อ รายละเอียดรายงานผลการใช้จ่ายเงิน เป็น แบบรายงานผลการดำเนินงานโครงการ (แบบ กท. 3/1)
            lstFileSpendingPlan_2: lstFileSpendingPlan_2, //เอกสารแนบ << แบบรายงานสรุปผลการดำเนินงานรายไตรมาส กท.3/1 > รายไตรมาส //Enh.2025 เปลี่ยนชื่อ แบบรายงานสรุปผลการดำเนินงานรายไตรมาส เป็น เอกสารประกอบการเบิกจ่าย
        };
        DialogFn.Submit(("คุณต้องการ" + sMessage + "หรือไม่ ?"), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectQuater, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success) {
                    setnProgressID(result.objResult?.nProgressID);

                    DialogFn.Success((sMessage + "สำเร็จ"), () => {
                        if (nModeID !== EnumSaveModeProject.UpdateFile && nModeID !== EnumSaveModeProject.Draft) {
                            if (nStatusID !== EnumProjectStatusID.nStatusID_35 && nStatusID !== EnumProjectStatusID.nStatusID_99) {
                                handleBack();
                            } else if (nStatusID === EnumProjectStatusID.nStatusID_35) {
                                // setisChangeUpdateProgress(true);
                                window.location.reload();
                            } else if (nStatusID === EnumProjectStatusID.nStatusID_99) {
                                document.getElementById("myDivUpdateProgress").scrollIntoView({ behavior: "smooth" });
                            }
                        }
                        if (isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                        if (isEditProgressOld && isModeSecretary === true) setisEditProgressOld(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const handleBack = () => {
        let sNameBack = "/Project";
        let sPathName = Router.GetCurrentRoute();
        if (sPathName === "/projectsrequestingfrom") sNameBack = "/ProjectList";
        navigate(sPathNameBack !== null ? sPathNameBack : sNameBack);
    }

    useEffect(() => {
        if (ObjStepFlowProject !== null && sMode !== null) {
            setisEdit(sMode === "UpdateProgress" ? (ObjStepFlowProject?.isPermission_Tab6) : ((ObjStepFlowProject?.isPermission_Tab6 && isModeSecretary) ? true : false));
        }
    }, [ObjStepFlowProject, sMode]);

    // useEffect(() => {
    //     setisEdit((isModeSecretary === true) ? false : isPermission);
    // }, [isModeSecretary]);

    const [isEditSecretaryProgressOld, setisEditSecretaryProgressOld] = useState(false); // Enh.2025 > เลขา กดบันทึกและยอมรับผล : ยังสามารถแก้ไข Q ไตรมาสที่ผ่านมาได้ < แก้ไขได้ กท 3/1 - แท็บ รายงานผลการปฎิบัติงาน: แก้ไขได้ทั้งหมด แสดงปุ่ม บันทึก - แท็บ รายงานผลการใช้จ่ายเงิน: แก้ไขไม่ได้ 
    useEffect(() => {
        // Enh.2025 > เปลี่ยนจาก แก้ไขไม่ได้และไม่มีปุ่มอะไร ได้แค่ดูจนกว่าจะถึงช่วงวันให้อัพเดตไตรมาสถัดไป เป็น เลขา กดบันทึกและยอมรับผล : ยังสามารถแก้ไข Q ไตรมาสที่ผ่านมาได้ < แก้ไขได้ กท 3/1 - แท็บ รายงานผลการปฎิบัติงาน: แก้ไขได้ทั้งหมด แสดงปุ่ม บันทึก - แท็บ รายงานผลการใช้จ่ายเงิน: แก้ไขไม่ได้ 
        // หากมีข้อมูลที่ต้องการเพิ่มในไตรมาสที่ 1 แต่มาถึงช่วงเวลาของการรายงานไตรมาสที่ 2 แล้ว ต้องการให้เพิ่มข้อมูลในไตรมาสที่ 1 ได้ เนื่องจากอาจเป็นข้อมูลสำคัญ
        // > หากจะเพิ่มข้อมูลในส่วนของไตรมาส 1 ต้องการให้เปิดแก้ไขเฉพาะผลของการดำเนินงานเท่านั้น (ไม่สามารถแก้ไขส่วนของแผนการดำเนินงาน แผนการใช้เงิน และผลการใช้เงินได้)
        // = กรณีที่เลยช่วงระยะเวลาไตรมาสเดิมไปแล้ว ระบบจะเปิดให้แก้ไขข้อมูลของไตรมาสเดิมได้เฉพาะผลการดำเนินงาน ส่วนแผนและผลการใช้เงินไม่สามารถปรับแก้ไขได้
        // เลขา >> บันทึก : อัพเดตไตรมาส จาก Q ปัจุบัน - 1 กับ Q ปัจุบัน ที่มีการกดบันทึกยอมรับผลไปแล้ว
        //// (isModeSecretary === true && (form.getValues("nYearID") === nCurrentYear ? (nQuaterID === (nCurrentQ - 1) || nQuaterID === nCurrentQ) : form.getValues("nYearID") < nCurrentYear && nCurrentQ === 1 ? nQuaterID === 4 : false) && isPermission && !arrNotEditProgres.includes(_nProgressStatusID) 

        const nYearID = form.getValues("nYearID");
        const arrNotEditProgres = [25, 26, 27, 28, 29, 33, 36]; //_nProgressStatusID
        let isCurrentYear = false;
        if (isModeSecretary === true && isPermission && !arrNotEditProgres.includes(_nProgressStatusID)) {
            if (ObjStepFlowProject?.isBtn_ProgressConfirm || (ObjStepFlowProject?.isBtn_ProgressSend && isQuaterEnd)) {
                // ถึงระยะ รายงาน Q ปัจุบัน
                isCurrentYear = nYearID === nCurrentYear ? nQuaterID === (nCurrentQ - 1) : nYearID < nCurrentYear && nCurrentQ === 1 ? nQuaterID === 4 : false;
            } else if (!ObjStepFlowProject?.isBtn_ProgressConfirm) {
                // ยังไม่ถึงระยะ รายงาน Q ปัจุบัน
                if (nYearID === nCurrentYear) {
                    // ปีนี้
                    isCurrentYear = nQuaterID === (nCurrentQ - 1) || nQuaterID === (nCurrentQ - 2) ? true : false;
                } else if (nYearID < nCurrentYear) {
                    // ปีที่แล้ว
                    isCurrentYear = nCurrentQ === 1 ? ((nQuaterID === 4 || nQuaterID === 3) ? true : false) : ((nCurrentQ === 2 && nQuaterID === 4) ? true : false);
                }
            }
            setisEditSecretaryProgressOld(isCurrentYear);
            if (isEditProgressOld) setisEditProgressOld(false);
        } else {
            setisEditSecretaryProgressOld(false);
            if (isEditProgressOld) setisEditProgressOld(false);
        }
    }, [ObjStepFlowProject?.isBtn_ProgressConfirm, isModeSecretary, isPermission, nCurrentYear, nQuaterID, nCurrentQ, form.watch("nYearID")]);

    const CallTabQuater = useCallback(() => {
        //// //Enh.2025 เลขา >> บันทึก : อัพเดตไตรมาส จาก Q ปัจุบัน - 1 กับ Q ปัจุบัน ที่มีการกดบันทึกยอมรับผลไปแล้ว
        //// const isEditProgressBtn = (isModeSecretary === true && (form.getValues("nYearID") === nCurrentYear ? (nQuaterID === (nCurrentQ - 1) || nQuaterID === nCurrentQ) : form.getValues("nYearID") < nCurrentYear && nCurrentQ === 1 ? nQuaterID === 4 : false) && isPermission && !arrNotEditProgres.includes(_nProgressStatusID)); //&& !isQuaterEnd 
        //// if (!isEditProgressBtn && isEditProgressOld) setisEditProgressOld(false);      

        return (
            <Tabs id={"TabQuater"} defaultTab={TabQuaterID} onTabChange={(e) => { setTabQuaterID(e); }}>
                {arrQuater.map(itemQuater => {
                    let nQuarter = Convert.StringToInt(itemQuater.value);
                    let nYearID = Convert.StringToInt(itemQuater.nYearID);
                    return (
                        <TabItem
                            id={itemQuater.key}
                            isSub={true}
                            idHeadSub={"Project_Tab_Kth3_" + nQuarter}
                            sBackgroundTab={sBackgroundTab}
                            sBackgroundTabActive={sBackgroundTabActive}
                            // isDisabled={(nQuarter <= nCurrentQ && nYearID <= nCurrentYear) ? false : true}
                            isDisabled={(nYearID === nCurrentYear ? (nQuarter <= nCurrentQ ? false : true) : (nYearID > nCurrentYear ? true : false))}
                        >
                            {ParseHtml(itemQuater.label)}
                        </TabItem>
                    )
                })}
                <TabContent id={"tabcontent-quater"}>
                    {arrQuater.filter(f => f.key === TabQuaterID).map(itemQuater => {
                        let nQuarter = Convert.StringToInt(itemQuater.value);
                        let nYearID = Convert.StringToInt(itemQuater.nYearID);
                        return (
                            <TabPanel
                                id={itemQuater.key}
                                isSub={true}
                                idHeadSub={"Project_Tab_Kth3_" + nQuarter}
                            >
                                <TabQuater
                                    tabid={itemQuater.key}
                                    nQuarter={nQuarter}
                                    form={form}
                                    nProjectID={nProjectID}
                                    nYearID={form.getValues("nYearID")}
                                    isDisabledQuater={(nYearID === nCurrentYear ? (nQuarter <= nCurrentQ ? false : true) : (nYearID > nCurrentYear ? true : false))}
                                    nCurrentYear={nCurrentYear}
                                    isEditProgressOld={isEditProgressOld} // Enh.2025 เลขา >> บันทึก : อัพเดตไตรมาส จาก Q ปัจุบัน - 1  กับ Q ปัจุบัน ที่มีการกดบันทึกยอมรับผลไปแล้ว
                                />
                            </TabPanel>
                        )
                    })}
                </TabContent>
            </Tabs>
        );
    }, [TabQuaterID, arrQuater, nCurrentQ, nCurrentYear, isEditProgressOld]); // isEditProgressOld > Enh.2025 เลขา >> บันทึก : อัพเดตไตรมาส จาก Q ปัจุบัน - 1 กับ Q ปัจุบัน ที่มีการกดบันทึกยอมรับผลไปแล้ว

    return (
        <ProjectUpdateProgressContext.Provider
            value={useMemo(() => ({
                nProjectID: nProjectID,
                isPermission: isPermission,
                ObjProjectRequest: ObjProjectRequest,
                nStatusID: nStatusID,
                ObjStepFlowProject: ObjStepFlowProject,
                isModeSecretary: isModeSecretary,
                setsActivitySummarize: setsActivitySummarize,
                nQuaterID: nQuaterID,
                setnQuaterID: setnQuaterID,
                set_lstProjectWorkPlan: set_lstProjectWorkPlan,
                set_lstProjectSpendingPlanType: set_lstProjectSpendingPlanType,
                _nProgressStatusID: _nProgressStatusID,
                set_nProgressStatusID: set_nProgressStatusID,
                _nUpdateProgressStatusID: _nUpdateProgressStatusID,
                set_nUpdateProgressStatusID: set_nUpdateProgressStatusID,
                isQuaterEnd: isQuaterEnd,
                isEdit: isEdit,
                arrYear: arrYear,
                nProgressID: nProgressID,
                setnProgressID: setnProgressID,
                nApproveBudget: nApproveBudget,
                nCurrentQ: nCurrentQ,
                nCurrentYear: nCurrentYear,
                isEditSecretary,
                lstFileSpendingPlan_1,
                setlstFileSpendingPlan_1,
                lstFileSpendingPlan_2,
                setlstFileSpendingPlan_2,
            }),
                [
                    nProjectID,
                    isPermission,
                    ObjProjectRequest,
                    nStatusID,
                    ObjStepFlowProject,
                    isModeSecretary,
                    setsActivitySummarize,
                    nQuaterID,
                    setnQuaterID,
                    set_lstProjectWorkPlan,
                    set_lstProjectSpendingPlanType,
                    _nProgressStatusID,
                    set_nProgressStatusID,
                    _nUpdateProgressStatusID,
                    set_nUpdateProgressStatusID,
                    isQuaterEnd,
                    isEdit,
                    arrYear,
                    nProgressID,
                    setnProgressID,
                    nApproveBudget,
                    nCurrentQ,
                    nCurrentYear,
                    isEditSecretary,
                    lstFileSpendingPlan_1,
                    setlstFileSpendingPlan_1,
                    lstFileSpendingPlan_2,
                    setlstFileSpendingPlan_2,
                ])}
        >
            <Grid item xs={12} md={12} container spacing={2}>
                <FormProvider {...form}>
                    <Grid id={"myDivUpdateProgress"} item xs={12} md={12} container spacing={2} alignItems={"flex-start"} justifyContent={"center"} style={{ margin: 'auto', }}>
                        <Grid item xs={12} md={12} container spacing={3} alignItems={"center"} justifyContent={"center"}>
                            <Grid item>
                                <Typography variant='h6' color={'#a73b27'} textAlign={"center"}>รายงานความคืบหน้าโครงการรายไตรมาส แบบ กท 3/1</Typography>
                            </Grid>
                            <Grid item xs={12} sm={1.5}>
                                <SelectItem
                                    id="nYearID"
                                    name="nYearID"
                                    options={arrYear}
                                    label={"ปีบัญชี"}
                                    required={true}
                                    IsClearable={true}
                                    onChange={(e) => {
                                        GetFormQuater(e?.value ?? null);
                                    }}
                                // disabled={!isEdit}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={1} alignItems={"center"} justifyContent={"center"}>
                            <CallTabQuater />
                            {/* <Tabs id={"TabQuater"} defaultTab={TabQuaterID} onTabChange={(e) => { setTabQuaterID(e); }}>
                                {arrQuater.map(itemQuater => {
                                    let nQuarter = Convert.StringToInt(itemQuater.value);
                                    let nYearID = Convert.StringToInt(itemQuater.nYearID);
                                    return (
                                        <TabItem
                                            id={itemQuater.key}
                                            isSub={true}
                                            idHeadSub={"Project_Tab_Kth3_" + nQuarter}
                                            sBackgroundTab={sBackgroundTab}
                                            sBackgroundTabActive={sBackgroundTabActive}
                                            // isDisabled={(nQuarter <= nCurrentQ && nYearID <= nCurrentYear) ? false : true}
                                            isDisabled={(nYearID === nCurrentYear ? (nQuarter <= nCurrentQ ? false : true) : (nYearID > nCurrentYear ? true : false) )}
                                        >
                                            {ParseHtml(itemQuater.label)}
                                        </TabItem>
                                    )
                                })}
                                <TabContent id={"tabcontent-quater"}>
                                    {arrQuater.filter(f => f.key === TabQuaterID).map(itemQuater => {
                                        let nQuarter = Convert.StringToInt(itemQuater.value);
                                        let nYearID = Convert.StringToInt(itemQuater.nYearID);
                                        return (
                                            <TabPanel
                                                id={itemQuater.key}
                                                isSub={true}
                                                idHeadSub={"Project_Tab_Kth3_" + nQuarter}
                                            >
                                                <TabQuater
                                                    tabid={itemQuater.key}
                                                    nQuarter={nQuarter}
                                                    form={form}
                                                    nProjectID={nProjectID}
                                                    nYearID={form.getValues("nYearID")}
                                                    isDisabledQuater={(nYearID === nCurrentYear ? (nQuarter <= nCurrentQ ? false : true) : (nYearID > nCurrentYear ? true : false) )}
                                                />
                                            </TabPanel>
                                        )
                                    })}
                                </TabContent>
                            </Tabs> */}
                        </Grid>
                        {(nProgressStatusID === EnumProjectStatusID.nStatusID_28 && isModeSecretary === true) ?
                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                {isEditSecretary === false ?
                                    <Grid item>
                                        <BtnEdit id={"btnEdit_Quater"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivUpdateProgress").scrollIntoView({ behavior: "smooth" }); }} />
                                    </Grid>
                                    :
                                    <>
                                        <Grid item>
                                            <BtnCancel id={"btnCancel_Quater"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); GetFormQuater(Convert.StringToIntOrNull(form.getValues("nYearID"))); }} />
                                        </Grid>
                                        <Grid item>
                                            <BtnSendRequest id={"btnSend_Quater"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.UpdateFile, _nProgressStatusID, I18n.SetText("Button.Save", I18NextNs.labelComponent)) }} />
                                        </Grid>
                                    </>
                                }
                            </Grid>
                            :
                            (isEdit && form.watch("nYearID") === nCurrentYear && nCurrentQ === nQuaterID ?
                                <Grid item xs={12} md={12} container spacing={1} justifyContent="center">
                                    {/* 
                                        isBtn_ProgressDraft << บันทึกร่าง
                                        isBtn_ProgressSend << บันทึก
                                        isBtn_ProgressSendEdit << ส่งกลับแก้ไข
                                        isBtn_ProgressConfirm << บันทึกและยอมรับผล 
                                    */}
                                    {ObjStepFlowProject?.isBtn_ProgressDraft &&
                                        // (nProgressID === 0 || ((nProgressID !== 0 && (_nUpdateProgressStatusID === EnumProjectStatusID.nStatusID_13 || ) ))) &&                             
                                        //Requester + หัวหน้า + ผู้ประสานงาน >> บันทึกร่าง
                                        <Grid item>
                                            <BtnDraft
                                                id="BtnDraft_Progress"
                                                txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)}
                                                IsDisabled={!isEdit}
                                                onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Draft, _nProgressStatusID, I18n.SetText("Button.Draft", I18NextNs.labelComponent)), (err) => {
                                                    document.getElementById(Object.keys(err)[0])?.focus();
                                                })}
                                            />
                                        </Grid>
                                    }
                                    {ObjStepFlowProject?.isBtn_ProgressSend &&
                                        //Requester + หัวหน้า + ผู้ประสานงาน & เลขา >> บันทึก >> รอเลขาตรวจสอบ
                                        <Grid item>
                                            <BtnSave
                                                id="BtnSubmit_Progress"
                                                // IsDisabled={!isSubmit}
                                                txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)}
                                                IsDisabled={!isEdit}
                                                onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit, (isQuaterEnd === true ? EnumProjectStatusID.nStatusID_35
                                                    : (nCurrentQ === 1 ? EnumProjectStatusID.nStatusID_17
                                                        : (nCurrentQ === 2 ? EnumProjectStatusID.nStatusID_18
                                                            : (nCurrentQ === 3 ? EnumProjectStatusID.nStatusID_19
                                                                : (nCurrentQ === 4 ? EnumProjectStatusID.nStatusID_20
                                                                    : 0))))), I18n.SetText("Button.Save", I18NextNs.labelComponent)), (err) => {
                                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                                    })}
                                            />
                                        </Grid>
                                    }
                                    {(ObjStepFlowProject?.isBtn_ProgressSendEdit && isModeSecretary === true && isPermission) &&
                                        //เลขา >> ส่งกลับแก้ไข
                                        <Grid item>
                                            <BtnEdit
                                                id="BtnRecall_Progress"
                                                txt={I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)}
                                                IsDisabled={!isEdit}
                                                // onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Reject, (isQuaterEnd === true ? EnumProjectStatusID.nStatusID_27 
                                                //                                                                                 : (nCurrentQ === 1 ? EnumProjectStatusID.nStatusID_21
                                                //                                                                                     : (nCurrentQ === 2 ? EnumProjectStatusID.nStatusID_22
                                                //                                                                                         : (nCurrentQ === 3 ? EnumProjectStatusID.nStatusID_23
                                                //                                                                                             : (nCurrentQ === 4 ? EnumProjectStatusID.nStatusID_24
                                                //                                                                                                 : 0))))), I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)),(err) => {
                                                //     document.getElementById(Object.keys(err)[0])?.focus();
                                                //     console.log("err", err);
                                                // })}
                                                onClick={(e) => { setisModalRecallProgress(true); }}
                                            />
                                        </Grid>
                                    }
                                    {(ObjStepFlowProject?.isBtn_ProgressConfirm && isModeSecretary === true && isPermission) &&
                                        //เลขา >> บันทึกและยอมรับผล >> เลขาตรวจสอบแล้ว
                                        <Grid item>
                                            <BtnApprove
                                                id="BtnConfirm_Progress"
                                                // IsDisabled={!isSubmit}
                                                bgcolor={"#00aeef"}
                                                bgcolorHover={"#0799d0"}
                                                txt={"บันทึกและยอมรับผล"}
                                                IsDisabled={!isEdit}
                                                onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Approve, EnumProjectStatusID.nStatusID_32, "บันทึกและยอมรับผล"), (err) => {
                                                    document.getElementById(Object.keys(err)[0])?.focus();
                                                })}
                                            />
                                        </Grid>
                                    }
                                </Grid>
                                :
                                //เลขา >> บันทึก : อัพเดตไตรมาส จาก Q ปัจุบัน - 1 กับ Q ปัจุบัน ที่มีการกดบันทึกยอมรับผลไปแล้ว
                                // Enh.2025 > เปลี่ยนจาก แก้ไขไม่ได้และไม่มีปุ่มอะไร ได้แค่ดูจนกว่าจะถึงช่วงวันให้อัพเดตไตรมาสถัดไป เป็น เลขา กดบันทึกและยอมรับผล : ยังสามารถแก้ไข Q ไตรมาสที่ผ่านมาได้ < แก้ไขได้ กท 3/1 - แท็บ รายงานผลการปฎิบัติงาน: แก้ไขได้ทั้งหมด แสดงปุ่ม บันทึก - แท็บ รายงานผลการใช้จ่ายเงิน: แก้ไขไม่ได้ 
                                // หากมีข้อมูลที่ต้องการเพิ่มในไตรมาสที่ 1 แต่มาถึงช่วงเวลาของการรายงานไตรมาสที่ 2 แล้ว ต้องการให้เพิ่มข้อมูลในไตรมาสที่ 1 ได้ เนื่องจากอาจเป็นข้อมูลสำคัญ
                                // > หากจะเพิ่มข้อมูลในส่วนของไตรมาส 1 ต้องการให้เปิดแก้ไขเฉพาะผลของการดำเนินงานเท่านั้น (ไม่สามารถแก้ไขส่วนของแผนการดำเนินงาน แผนการใช้เงิน และผลการใช้เงินได้)
                                // = กรณีที่เลยช่วงระยะเวลาไตรมาสเดิมไปแล้ว ระบบจะเปิดให้แก้ไขข้อมูลของไตรมาสเดิมได้เฉพาะผลการดำเนินงาน ส่วนแผนและผลการใช้เงินไม่สามารถปรับแก้ไขได้
                                //// <CallEditProgressBtn />
                                ////((isModeSecretary === true && (form.getValues("nYearID") === nCurrentYear ? (nQuaterID === (nCurrentQ - 1) || nQuaterID === nCurrentQ) : form.getValues("nYearID") < nCurrentYear && nCurrentQ === 1 ? nQuaterID === 4 : false) && isPermission && !arrNotEditProgres.includes(_nProgressStatusID)) && //&& !isQuaterEnd 
                                (isEditSecretaryProgressOld &&
                                    //// <Grid item xs={12} md={12} container spacing={1} justifyContent="center">
                                    ////     <Grid item>
                                    ////         <BtnSave 
                                    ////             id="BtnSubmit_Progress"
                                    ////             txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)}
                                    ////             onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Save, EnumProjectStatusID.nStatusID_99, I18n.SetText("Button.Save", I18NextNs.labelComponent)),(err) => {
                                    ////                 document.getElementById(Object.keys(err)[0])?.focus();
                                    ////                 console.log("err", err);
                                    ////             })}
                                    ////         />
                                    ////     </Grid>
                                    //// </Grid>
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {isEditProgressOld === false ?
                                            <Grid item>
                                                <BtnEdit
                                                    id={"btnEdit_Quater"}
                                                    txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)}
                                                    onClick={() => {
                                                        setisEditProgressOld(true);
                                                        document.getElementById("myDivUpdateProgress").scrollIntoView({ behavior: "smooth" });
                                                    }}
                                                />
                                            </Grid>
                                            :
                                            <>
                                                <Grid item>
                                                    <BtnCancel
                                                        id={"btnCancel_Quater"}
                                                        txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)}
                                                        onClick={() => {
                                                            setisEditProgressOld(false);
                                                            GetFormQuater(Convert.StringToIntOrNull(form.getValues("nYearID")), nQuaterID);
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <BtnSendRequest
                                                        id={"btnSend_Quater"}
                                                        txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)}
                                                        onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Save, EnumProjectStatusID.nStatusID_99, I18n.SetText("Button.Save", I18NextNs.labelComponent)), (err) => {
                                                            document.getElementById(Object.keys(err)[0])?.focus();
                                                        })}
                                                    />
                                                </Grid>
                                            </>
                                        }
                                    </Grid>
                                )
                            )
                        }
                    </Grid>
                </FormProvider>
                {/* {isModalRecallProgress && 
                        <ModalRemark 
                            isOpenRemark={isModalRecallProgress} 
                            setIsOpenRemark={setisModalRecallProgress} 
                            sRemark={sRemark} 
                            setsRemark={setsRemark} 
                            onSubmit={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Reject, (isQuaterEnd === true ? EnumProjectStatusID.nStatusID_27 
                                                                                                                : (nCurrentQ === 1 ? EnumProjectStatusID.nStatusID_21
                                                                                                                    : (nCurrentQ === 2 ? EnumProjectStatusID.nStatusID_22
                                                                                                                        : (nCurrentQ === 3 ? EnumProjectStatusID.nStatusID_23
                                                                                                                            : (nCurrentQ === 4 ? EnumProjectStatusID.nStatusID_24
                                                                                                                                : 0))))), I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)),(err) => {
                                document.getElementById(Object.keys(err)[0])?.focus();
                            })} 
                        /> 
                    } */}
                <DialogPreview
                    IsOpen={isModalRecallProgress}
                    Title={"ส่งกลับแก้ไข"}
                    onClose={() => { setisModalRecallProgress(false); formRemark.reset(); }}
                    sMaxWidth='xs'
                    CloseSave={true}
                >
                    <FormProvider {...formRemark}>
                        <TextAreaItem
                            label={""}
                            id={`sRemark`}
                            name={`sRemark`}
                            row={4}
                            required={isModalRecallProgress}
                            maxLength={500}
                        />
                        <Stack direction={"row"} justifyContent={"end"} sx={{ width: "100%", mt: 2, mb: 1 }}>
                            <BtnSave
                                id={"btnSave"}
                                onClick={formRemark.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Reject, (isQuaterEnd === true ? EnumProjectStatusID.nStatusID_27
                                    : (nCurrentQ === 1 ? EnumProjectStatusID.nStatusID_21
                                        : (nCurrentQ === 2 ? EnumProjectStatusID.nStatusID_22
                                            : (nCurrentQ === 3 ? EnumProjectStatusID.nStatusID_23
                                                : (nCurrentQ === 4 ? EnumProjectStatusID.nStatusID_24
                                                    : 0))))), I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)), (err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                    })}
                            />
                        </Stack>
                    </FormProvider>
                </DialogPreview>
            </Grid>
        </ProjectUpdateProgressContext.Provider>
    )
}

export default RequestKth31Page;
export { ProjectUpdateProgressContext };